import React, { useEffect, useRef } from 'react';
import classnames from 'classnames';
import noop from 'lodash/noop';

import Button from '@Components/Button';
import SelectWrapper from '@Components/Popup/SelectWrapper';
import SelectToggler from '@Components/Popup/SelectWrapper/SelectToggler';
import AvailableResultsList from '../AvailableResultsList';
import CurrentAvailableResult from './CurrentAvailableResult';

import './ResultsFrom.custom.scss';
import './ResultsFrom.theme.scss';

export function createAvailableResultsList(props, disabled) {
  if (disabled) {
    return () => null;
  }

  return function (wrapperProps) {
    return <AvailableResultsList {...props} wrapperProps={wrapperProps} />;
  };
}

export function createToggler(props, disabled) {
  const resultText = <CurrentAvailableResult {...props} />;

  if (disabled) {
    return function () {
      return (
        <SelectToggler isOpen={false} onClick={noop} disabled={disabled} className="select-toggler-secondary results-from--select-toggler">
          {resultText}
        </SelectToggler>
      );
    };
  }

  return function (wrapperProps) {
    const { toggle, isOpen } = wrapperProps;

    return (
      <SelectToggler isOpen={isOpen} onClick={toggle} disabled={disabled} className="select-toggler-secondary results-from--select-toggler">
        {resultText}
      </SelectToggler>
    );
  };
}

export default function ResultsFrom(props) {
  const { results, className, id, alert, fetchResultsInfo, selectedRunId } = props;
  const disabled = !results;
  const refValue = useRef(null);

  return (
    <>
      <section className={classnames('results-from', className)}>
        <span className="results-from--text">Results from:</span>

        <SelectWrapper
          disabled={disabled}
          className="results-from--select-wrapper"
          ref={refValue}
          contentWrapperClassName="results-from--select-wrapper-content"
          content={createAvailableResultsList(props, disabled)}
          size="sm">
          {createToggler(props, disabled)}
        </SelectWrapper>
      </section>
      <Button
        disabled={disabled}
        onClick={() => {
          fetchResultsInfo(alert, selectedRunId);
        }}
        buttonConfig={{
          className: 'alert-right-block--go-button',
          size: 'sm',
          type: 'primary-alt',
          e2eName: `alert-go-${id}`,
          ariaLabel: 'Go',
        }}
        iconConfig={{
          name: 'chevron-right',
        }}
      />
    </>
  );
}
